module.exports = __webpack_public_path__ + "img/close.c5232782.svg";